import { Box } from "@mui/material";
import * as React from "react";
import GeneralStatistics from "./GeneralStatistics";
import TimePeriodStats from "./TimePeriodStats";
import Grid from "@mui/material/Unstable_Grid2";

export default function StatsPage() {
  return (
    <Box sx={{ width: "100%" }}>
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid xs={12} sx={{}}>
          <GeneralStatistics />
        </Grid>
        <Grid xs={12} sx={{}}>
          <TimePeriodStats />
        </Grid>
        <Grid xs={6} sx={{}}></Grid>
        <Grid xs={6} sx={{}}></Grid>
      </Grid>
    </Box>
  );
}
